import {
  Component,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MatDialog,
  MatTableDataSource,
  PageEvent,
  MatDatepickerInputEvent,
  MatPaginator,
} from "@angular/material";
import * as moment from "moment";
import { AppService } from "src/_services/app.service";
import { Router } from "@angular/router";
import { SapRoles } from "src/_constants/roleType";
import { AuthenticationService } from "src/_services/authentication.service";
import { VoidBetsModalComponent } from "../bets-settlements/bets-settlements.component";

@Component({
  selector: 'app-alert-bets',
  templateUrl: './alert-bets.component.html',
  styleUrls: ['./alert-bets.component.scss']
})
export class AlertBetsComponent implements OnInit {
  betDisplayedColumns: string[] = [
    "Date",
    "Username",
    "Sports",
    "Event",
    "OperatorId",
    "MarketType",
    "Odds",
    "Stake",
    "currency",
    "status",
    "Returns",
    "Reported By",
    "Remarks",
    "Action",
  ];

  today = new Date();
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  formDate = new FormControl(this.today);
  toDate = new FormControl(new Date(this.today.getTime() + 86400000));
  bets = new MatTableDataSource<any>();
  totalRecords: number;
  sapRoles = SapRoles;
  alertStatus = new FormControl([]);
  selectedStatus = "";

  showAlert: any = false;
  allAlertStatus = ["Alert", "Accept","Void"]
  betStatusList = ["Alert","Valid","Voided"];

  selected: any = {
    startDate: moment().subtract(6, "days"),
    endDate: moment(),
  };
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  providers: any = JSON.parse(sessionStorage.getItem("category"));
  length: any = 0;

  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  dropdownSettings: any = {};

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
   this.getBetList();
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getBetList();
  }

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.page = 1;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;
      if (diff > 7) {
        this.showAlert = true;
        this.selected.startDate = moment(new Date().setHours(0, 0, 0, 0));
        this.selected.endDate = moment(new Date().setHours(23, 59, 59));
        setTimeout(() => {
          this.showAlert = false;
        }, 5000);
      } else if (this.selected.startDate !== null) {
        this.getBetList();
      }
    }
  };

  onFilterChange() {
    this.page = 1;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.getBetList();
  }

  truncate(value: string, limit: number): string {
    if (value.length > limit) {
      return value.slice(0, limit) + (value.length > limit ? '...' : '');
    }
    return value;
  }

  getBetList() {
    const pagination = {
      Number: 10,
      Page: 1,
    };

    let filters = {
      startTime:
        this.selected.startDate !== null
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
      PageSize: this.orgPageSize,
      Page: this.page,
      alertStatus: this.alertStatus.value[0],
    };

    this.appService.getAlertBets(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.bets = new MatTableDataSource<any>(res.betList);
        if (this.page == 1) {
          this.length = res.totalBets;
        } else {
          this.paginator.length = this.length;
        }
      }
    });
  }

  getBetPlaceDate = (date: number) => {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  };

  onSelectedalertStatus(value) {
    if (value === "Valid") {
      this.alertStatus.value[0] = "Accept"
    } else if (value === "Voided") {
      this.alertStatus.value[0] = "Void"
    } else {
      this.alertStatus.value[0] = value
    }
  }

  onCorrectButtonClick(element) {
    if (element.status === 'OPEN' || element.status === 'SETTLED') {
      let filters = {
        transactionId: element.transactionId,
        alertStatus: "Accept"
      }
      this.appService.settleAlertedBet(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.getBetList();
          this.authenticationService.openSnackBar("Bet Accepted");
        } 
      });
    } else {
      this.authenticationService.openErrorSnackBar("Invalid Bet Status");
    }
  }

  onWrongButtonClick(element) {
    if (element.status === 'OPEN' || element.status === 'SETTLED') {
        try {
          let dialogRef = this.dialog.open(VoidBetsModalComponent, {
            backdropClass: "backdropBackground",
            hasBackdrop: true,
            data: {
              transactionId: element.transactionId,
              alertStatus: "Void",
              status: element.status
            },
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.getBetList();
            }
          });
        } catch (err) {}
    } else {
      this.authenticationService.openErrorSnackBar("Invalid Bet Status");
    }
  }
}
